import { render, staticRenderFns } from "./cardReportes.vue?vue&type=template&id=3240210e&scoped=true"
import script from "./cardReportes.vue?vue&type=script&lang=js"
export * from "./cardReportes.vue?vue&type=script&lang=js"
import style0 from "./cardReportes.vue?vue&type=style&index=0&id=3240210e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240210e",
  null
  
)

export default component.exports